export default __webpack_public_path__ + "static/media/co.49a1e31d.svg";